<template>
  <div class="ui form">
    <div class="fields">
      <div class="eight column wide field">
        <label>{{ $t("from") }}</label>
        <input
          type="text"
          name="from"
          placeholder="Your mailer name <example@gomodul.com>"
          v-model="setup.from"
        />
      </div>
      <div class="four column wide field">
        <label>{{ $t("user") }}</label>
        <input
          type="text"
          name="user"
          :placeholder="$t('user')"
          v-model="setup.user"
        />
      </div>
      <div class="four column wide field">
        <label>{{ $t("password") }}</label>
        <input
          type="password"
          name="password"
          :placeholder="$t('password')"
          v-model="setup.password"
        />
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/filters";

export default {
  name: "EmailModalOutlook",
  filters: filters,
  components: {},
  computed: {},
  props: { selected_configuration: Object },
  data() {
    return {
      setup: {
        user: "",
        password: "",
        from: "",
      },
    };
  },
  methods: {
    getSetup() {
      return this.setup;
    },
  },
  created() {},
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    if (vm.selected_configuration) {
      vm.setup = vm.selected_configuration.setup;
    }
  },
  watch: {},
};
</script>
